<script>
  import { navigate } from "svelte-routing";

  /* Executable code section of the program */

  //Auxiliary variables
  export let eventInfo;
  
  let eventWallpaper = eventInfo.eventMultimedia.eventWallpaperUrl;
  let colorBtn = eventInfo.colorEvent;
  
  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<div
  class="componentContainer"
  style="--event-Wallpaper: {eventWallpaper}; background-image: url({eventWallpaper});"
>
  <div class="imgContainer">
    <img src={eventInfo.eventMultimedia.eventImgUrl} alt="EventPoster" />
  </div>
  <div class="buttonsContainer">
    <button
      class="actionBtn"
      on:click={() => navigate(`/event/${eventInfo.id}/${eventInfo.tittle}`)}
      style="--event-color: {colorBtn};">Go To The Event</button
    >
  </div>
</div>

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  .componentContainer {
    width: 90%;
    height: auto;
    background-size: cover;
    background-position: center;
    padding: 15px 0;
    display: flex;
  }
  .imgContainer {
    width: 70%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  img {
    width: 80%;
    height: auto;
  }
  .buttonsContainer {
    background-color: rgba(0, 0, 0, 0.425);
    width: 60%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 10px 30px;
  }
  .actionBtn {
    background-color: white;
    width: 200px;
    height: 50px;
    border-radius: 12px;
    font-size: 15px;
    font-weight: 500;
    padding: 5px 10px;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 5px;
  }

  .actionBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: var(--event-color);
    color: White;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    
  .imgContainer {
    width: 100%;
  }
    img {
      width: 100%;
      height: auto;
    }
    .actionBtn {
    background-color: white;
    width: 200px;
    height: 50px;
    font-size: 15px;
    font-weight: 500;
    padding: 5px 10px;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 5px;
  }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .componentContainer {
    width: 90%;
    height: auto;
    background-size: cover;
    background-position: center;
    padding: 15px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .imgContainer {
    width: 100%;
  }
    img {
      width: 100%;
      height: auto;
    }
  }
  
  .buttonsContainer {
    background-color: rgba(0, 0, 0, 0);
    width: 90%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 10px 30px;
  }

  /* End of the section */
</style>
